<template>
    <div class="create-chatbot-wrapper">
        <WebsiteChatbotBuilder v-if="websiteBuilder" @cancel="() => (websiteBuilder = false)" />
        <div class="create-chatbot" v-else>
            <div class="sticky-header">
                <div class="title">Set up your chatbot</div>
                <div class="description">
                    Train your chatbot with data, use our ready-to-use templates or start from scratch.
                </div>
                <SupsisButton class="btnClose" small @click="close">
                    <i class="material-icons">close</i>
                </SupsisButton>
            </div>

            <div class="items">
                <div class="block block-scratch" @click="createBlankStory">
                    <div class="icon">
                        <i class="material-icons">add</i>
                    </div>
                    <div class="name">Blank Bot</div>
                    <div class="description">Create a blank chatbot, which you can train and customize later.</div>
                </div>
                <div class="block block-ai" @click="websiteBuilder = true">
                    <div class="ai-badge">
                        <span class="lang">ENGLISH/TURKISH</span>
                        <span>AI</span>
                    </div>
                    <div class="icon">
                        <i class="material-icons">public</i>
                    </div>
                    <div class="name">Website</div>
                    <div class="description">
                        Crawl your website’s content to get answers to popular user questions.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import WebsiteChatbotBuilder from "./WebsiteChatbotBuilder.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    name: "CreateChatbot",
    components: { WebsiteChatbotBuilder, SupsisButton },
    data() {
        return {
            websiteBuilder: false,
        };
    },
    methods: {
        ...mapActions({
            createEmptyStory: "CB/createEmptyStory",
        }),
        close() {
            this.$emit("close");
        },
        createBlankStory() {
            const hide = this.$message.loading({
                content: "Creating blank chatbot...",
                duration: 20,
            });
            this.createEmptyStory({
                title: "Untitled Chatbot",
                description: "",
            })
                .then(({ story }) => {
                    this.$router.push(`/chatbot/story/${story._id}/1.0`);
                })
                .catch((err) => {
                    this.$message.error({
                        content: `Error creating chatbot`,
                        duration: 3,
                    });
                })
                .finally(() => {
                    hide();
                    this.listStories();
                });
        },
    },
});
</script>

<style scoped lang="scss">
.create-chatbot-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    background: white;
    z-index: 99999;
}

.create-chatbot {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 100px;
    position: relative;
    height: 100%;
    overflow-y: auto;
    width: 100%;

    .sticky-header {
        background: #fff;
        max-width: 1600px;
        padding: 40px 0;
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title {
            font-size: 30px;
            line-height: 38px;
            color: #22272d;
            font-weight: 700;
        }

        .description {
            font-size: 18px;
            line-height: 23px;
        }

        .btnClose {
            position: absolute;
            right: 0;
        }
    }

    .items {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .block {
            background-color: #fff;
            border: 2px solid #f5f5f5;
            border-radius: 15px;
            cursor: pointer;
            padding: 20px;
            transition: border-color 0.1s;
            max-width: 400px;
            height: 175px;
            max-height: 175px;

            &:hover {
                border-color: #006cff !important;
            }

            .name {
                color: #22272d;
                font-size: 18px;
                font-weight: 600;
                line-height: 23px;
                margin-bottom: 8px;
                margin-top: 13px;
            }

            .description {
                color: #22272d;
                font-size: 16px;
                line-height: 20px;
            }

            &.block-scratch {
                .icon {
                    background: #f5f5f5;
                    border-radius: 100%;
                    display: flex;
                    height: 34px;
                    width: 34px;
                    align-items: center;
                    justify-content: center;
                }
            }

            &.block-ai {
                background: #fff;
                border-color: #f5f5f5;
                position: relative;

                .ai-badge {
                    display: flex;
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 16px;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    right: 10px;
                    top: 10px;

                    span {
                        background: #22272d;
                        border-radius: 6px;
                        color: #fff;
                        margin-left: 4px;
                        padding: 0 4px;

                        &.lang {
                            background: #f5f5f5;
                            color: #22272d;
                        }
                    }
                }

                .icon {
                    color: #006cff;
                    height: 34px;
                    margin-bottom: 12px;
                    width: 34px;
                }
            }
        }
    }
}
</style>
